<template>
  <div id="app">
    <el-container>
      <el-header height="150px">
        <div class="header">
          <img class="header_logo" src="../../../assets/home/home_purchase/yhyj3_03.png"/>
        </div>
      </el-header>
      <el-main>
        <div class="main">
          <div class="main_corlo">
            <div class="main_shangpin">

              <!--              <img class="main_shangpin_img" :src="url+'/storage/'+application.goods[0].cover"/>-->
              <el-image class="main_shangpin_img" :src="url+'/storage/'+application.pic"></el-image>
              <span class="shanpin_bianhao">订单编号: {{ application.order_no }}</span>
              <span class="shanpin_name">{{ application.title }}</span>
              <div class="shanpin_jine">{{application.pay_price}}</div>
              <!--            <div class="shangpin_daojishi">请在4天23时59分 内完成支付</div>-->

            </div>
          </div>
          <div class="main_biaoti">扫一扫支付(元)</div>
          <div class="main_jine">{{application.pay_price}}</div>
          <div style="width: 100%;
    margin: 0px auto;
    text-align: center;">
            <div>
              <div id="qrcode" align="center" style="margin-top: 54px;margin-bottom: 70px"></div>
            </div>

            <img style="margin: 0 auto " src="../../../assets/home/home_purchase/cbf0d3c16de385d69185deb18247564.png"/>
            <a @click="fukuan_shijian=true">
              <div style="margin: 10px auto;width: 428px;height: 80px; background: #EF4F3F;
    border-radius: 5px;
    text-align: center;
    line-height: 80px;
    font-size: 25px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;">已完成支付
              </div>
            </a>
          </div>
          <el-dialog
                  title="提示"
                  :visible.sync="fukuan_shijian"
                  width="30%"
          >
            <span>是否跳转到详情页下载</span>
            <span slot="footer" class="dialog-footer">
    <el-button @click="fukuan_shijian = false">取 消</el-button>
              <a :href="'home.html#/college/programme/'+ application.application_program_id">
    <el-button type="primary" @click="fukuan_shijian = false">确 定</el-button>
                </a>
  </span>
          </el-dialog>

        </div>
        <div style="width: 100%;height: 200px"></div>
      </el-main>
      <el-footer height="250px">
        <el-row class="footer footer_bottom">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="footer_width">
              <div class="glzy_top">
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">联系我们</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">隐私政策</span>
                </a>
              </div>
              <div class="glzy_bottom">
                <span class="footer_text2 ">
                  Copyright@2020 海粟智链（青岛）科技有限公司
                  版权所有鲁ICP备 19060515号-1</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
    import QRCode from "qrcodejs2";

    export default {
        name: 'App',
        data: function () {
            return {

                fukuan_shijian: false,
                url: '',
                token: '',
                order_id: '',
                application: '',
            }
        },
        methods: {
            init() {
                this.token = localStorage.getItem("token")
                this.url = window.config.api_url
                console.log(this.url);
                var t = this
                t.order_id = t.$route.params.order_id
                if (t.order_id) {
                    this.qrCode()
                    this.xinxi()
                }
            },

            xinxi() {
                var t = this
                var token = localStorage.getItem('token')
                var url = window.config.api_url + '/user/application/order/' + t.order_id + '?token=' + token
                t.axios.get(url).then(res => {
                    t.application = res.data
                })
            },
            qrCode() {
                var wx_url = ''
                var t = this
                var token = localStorage.getItem("token")
                var url = window.config.api_url
                    + '/user/application/order/wechatpay?token=' + token
                    + '&order_id=' + t.order_id
                t.axios.get(url).then(res => {
                    console.log(res.data)
                    if (res.data.code_url) {
                        wx_url = res.data.code_url
                        t.erweima(wx_url)
                    }
                })

            },
            erweima(wx_url) {

                this.$nextTick(function () {
                    document.getElementById("qrcode").innerHTML = "";
                    new QRCode("qrcode", {
                        width: 432,
                        height: 432,
                        text: wx_url,
                        colorDark: "#000000",
                        colorLight: "#ffffff"
                    });
                });
            },

        },
        created() {
            this.init()
        }
    }
</script>
<style lang="less">
  #qrcode {
    .img {
      width: 432px;
      height: 432px;
    }
  }
</style>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
  //@head_text : Source Han Sans CN;
  @font-face {

  }

  @import "../../../assets/css/home";
  .el-footer {
    background-color: #FFFFFF;
    color: #333;
    //text-align: center;
    padding: 0 0;
    //line-height: 60px;
  }

  .el-main {
    background-color: #FFFFFF;
    color: #333;
    //text-align: center;
    padding: 0 0;
    //line-height: 500px;
  }

  .el-header {
    background: #FFFFFF;
    padding: 0 0;
    //border-bottom: #4E6EF2 solid 3px;
  }

  #app {
    width: 100%;

    .header {
      height: 100%;
      width: 80%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;

      .header_logo {
        margin-top: 50px;
      }
    }

    .main {
      height: 100%;
      width: 80%;
      //height: 200px;
      max-width: 1200px;
      margin-bottom: 122px;
      margin-right: auto;
      margin-left: auto;

      .main_corlo {
        width: 100%;
        height: 169px;
        background: #EBF2F9;
        border-radius: 10px;
        float: left;
      }

      .main_shangpin {

        height: 86px;
        position: relative;
        background: #EBF2F9;
        margin-top: 45px;

        .main_shangpin_img {
          width: 85px;
          height: 85px;
          background: #FFFFFF;
          border: 1px solid #E1E1E1;
          margin-left: 40px;
        }

        .shanpin_bianhao {
          position: absolute;
          margin-left: 20px;
          //width: 209px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          //line-height: 100px;
        }

        .shanpin_name {
          margin-left: 20px;
          position: absolute;
          margin-top: 28px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
        }

        .shanpin_jine {
          margin-right: 40px;
          //width: 175px;
          //height: 36px;
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #EF4F3F;
          //line-height: 100px;
          float: right;
        }

        .shangpin_daojishi {
          //width: 182px;
          //height: 14px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
          float: right;
          //width: 70%;
          //line-height: 100px;
        }

        .shangpin_daojishi2 {
          color: #EF4F3F;
        }
      }

      .main_biaoti {
        width: 100%;
        float: left;
        margin-top: 80px;
        text-align: center;
        //width: 211px;
        //height: 34px;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        //line-height: 18px;
      }

      .main_jine {
        margin-top: 21px;
        text-align: center;
        //width: 175px;
        //height: 36px;
        font-size: 46px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #EF4F3F;
        //line-height: 100px;
      }
    }

    .footer {
      width: 100%;
      height: 255px;
      background: #FFFFFF;
      border-bottom: #E1E1E1 solid 1px;

      .footer_width {
        width: 80%;
        max-width: 1200px;
        margin-right: auto;
        margin-left: auto;

        .xdsk_top {
          position: relative;
          margin-top: 70px;

          .footer_img_xinshou {
            //margin-left: 5px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_img_duiwai {
            //margin-left: 155px;
            //margin-top: 13px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_img_shiming {
            //margin-left: 155px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_img_kefu {
            //margin-left: 155px;
            //margin-top: 13px;
            position: absolute;
            width: 50px;
            height: 50px;
          }

          .footer_xinshou_left {
            margin-left: 60px;
          }

          .footer_dsk_left {
            margin-left: 60px;
          }
        }

        .xdsk_bottom {
          margin-top: 38px;

          .footer_kongjian_left {
            margin-left: 17px;
          }

          .footer_jiaoyi_left {
            margin-left: 184px;
          }

          .footer_shiming_left {
          }

          .footer_tousu_left {
            margin-left: 520px;
          }

          .footer_changjian_left {
            margin-left: 945px;
          }
        }

        .glzy_top {
          margin-top: 51px;

          .footer_gyyyj_left {
            padding-right: 20px;
            border-right: #E1E1E1 solid 1px;
          }

          .footer_lxwm_left {
            margin-left: 29px;
            padding-right: 21px;
            border-right: #E1E1E1 solid 1px;
          }
        }

        .glzy_bottom {
          margin-top: 45px;
        }
      }
    }

    .footer_bottom {
      border-bottom: none;
      height: 223px;
    }
  }

  .youfudong {
    float: right;
  }

  .main_text {
    //width: 69px;
    //height: 14px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #666666;
    //line-height: 100px;
  }

  .main_text1 {
    //width: 108px;
    //height: 12px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    //line-height: 100px;
  }

  .head_text {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 550;
    color: #333333;
    line-height: 38px;
  }

  .footer_text1 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 150;
    color: #666666;
    //line-height: 30px;
  }

  .footer_text2 {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    //line-height: 30px;
  }

  .footer_text3 {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 550;
    color: #333333;
    //line-height: 30px;
  }

  .xuanzhong:hover {
    //color:#4E6EF2;
    text-decoration: none;
  }

  .wenzi {
    text-decoration: none;
  }
</style>